import React from 'react';
import { CheckIcon, SmartphoneIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { instantAccess } from '../data/content';
export function InstantAccess() {
  return <section className="border-t border-ink-700 bg-ink-900 px-4 py-12 sm:px-6 sm:py-16" data-id="element-164" data-mp="1r8jjkkubwev1">
      <div className="mx-auto w-full max-w-3xl" data-id="element-165" data-mp="1v93cfc7vcwbd">
        <div className="mx-auto mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-brand/15" data-id="element-166" data-mp="1hjjf4lx24r9g">
          <SmartphoneIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-167" data-mp="1m9q44mvheds8" />
        </div>
        <SectionHeading eyebrow="Sofortiger Zugang" title="Was erhältst du sofort?" data-id="element-168" data-mp="17ldes8qwft6p" />

        <ul className="mt-8 grid gap-3" data-id="element-169" data-mp="17j93v6ul1twx">
          {instantAccess.map(item => <li key={item} className="flex gap-3 rounded-xl border border-ink-700 bg-ink-800 px-4 py-3" data-id="element-170" data-mp="1ci3v8x6m8qsn">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-171" data-mp="13jrtbz0au6kw" />
              <span className="text-[15px] leading-snug text-white/85" data-id="element-172" data-mp="1w41n1zslyitn">{item}</span>
            </li>)}
        </ul>

        <p className="mt-6 text-center text-[15px] leading-relaxed text-white/70" data-id="element-173" data-mp="1s27qa2lj9yyr">
          Jedes Mal, wenn du in der Werkstatt eine Frage hast, öffnest du das entsprechende Handbuch
          und findest die Antwort in wenigen Minuten.
          <span className="mt-2 block font-semibold text-white" data-id="element-174" data-mp="211uusx9k7kw1">
            Alles auf deinem Smartphone und mit einer einzigen Zahlung.
          </span>
        </p>

        <CtaBlock label="Ich will das Meister-System" className="mt-8" data-id="element-175" data-mp="18gbi0b9b6dey" />
      </div>
    </section>;
}